export default {"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};